import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {Field, reduxForm} from "redux-form";
import OrangeLinkWithArrow from "./OrangeLinkWithArrow";
import {email, required} from "../validators";
import CloseButton from "./CloseButton";


class SubscribeForm extends Component {
  render() {
    const {classes, valid, handleSubmit, closePopup, submitting} = this.props;

    return (
      <form onSubmit={handleSubmit} className={classes.form}>
        <div className={classes.body}>
          <div className={classes.title}>
            See the inner workings:
          </div>
          <div className={classes.name}>
            <Field
              className={classes.field}
              name="firstName"
              placeholder="First Name"
              component="input"
              validate={[required]}
            />
            <Field
              className={classes.field}
              name="lastName"
              placeholder="Last Name"
              component="input"
              validate={[required]}
            />
          </div>
          <Field
            className={classes.field}
            name="email"
            placeholder="Email"
            component="input"
            type="email"
            validate={[required, email]}
          />
        </div>
        <div className={classes.action}>
          <OrangeLinkWithArrow
            disabled={!valid}
            type="submit">{(submitting) ? 'Subscribing' : 'Subscribe'}</OrangeLinkWithArrow>
        </div>
        <CloseButton className={classes.closeButton} onClick={closePopup}/>
      </form>
    );
  }
}


export default withStyles((theme) => ({
  form: {
    position: 'relative',
  },
  body: {
    background: theme.palette.primary.main,
    padding: theme.spacing.unit * 2,
  },
  action: {
    background: theme.palette.secondary.dark,
    padding: theme.spacing.unit * 2,
    textAlign: 'right',
  },
  title: {
    color: theme.palette.secondary.dark,
    ...theme.typography.hg14bu(theme),
    marginBottom: theme.spacing.unit * 2,
  },
  name: {
    display: 'flex',
    '& > *:first-child': {
      marginRight: theme.spacing.unit,
    },
    '& > *:last-child': {
      marginLeft: theme.spacing.unit,
    }
  },
  field: {
    width: '100%',
    marginBottom: theme.spacing.unit,
    color: theme.palette.secondary.dark,
    ...theme.typography.hg18r(theme),
    borderBottom: `1px solid ${theme.palette.secondary.dark}`,
    '&::placeholder': {
      color: theme.palette.secondary.dark,
      ...theme.typography.hg18r(theme),
    }
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing.unit * 2,
    top: theme.spacing.unit * 2,
  }
}))(
  reduxForm({
    form: 'subscribeForm',
  })(SubscribeForm)
);



// WEBPACK FOOTER //
// ./src/parts/SubscribeForm.js